<template>
    <section class="l-section l-section--main">
        <div
            class="l-container l-container--main"
            v-if="customer"
        >
            <offer-tabs />
            <div class="l-row">
                <div class="l-row__column l-row__column--10">
                    <offer-cart-summary/>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import OfferCartSummary from '@/components/offer/OfferCartSummary'
import OfferTabs from '@/components/offer/OfferTabs'

export default {
    metaInfo: {
        title: 'Podsumowanie'
    },
    components: {
        OfferCartSummary,
        OfferTabs
    },
    computed: {
        currentAddress() {
            return this.$store.getters.currentAddress
        },
        customer() {
            return this.$store.getters.customer
        }
    },
    methods: {
        handleResize() {
            // on desktop redirect to global route
            if(window.innerWidth > 1024) {
                this.$router.push({ name: 'offer-cart', params: { slug: this.$route.params.slug } })
            }
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
        // get app state
        if(this.$route.params.slug && this.$route.params.slug.length > 0) {
            this.$store.dispatch('fetchOffer', this.$route.params.slug)
        } else {
            this.$store.dispatch('addNotification', {
                type: 'danger',
                content: 'Brak poprawnego ifentyfikatora oferty.',
                limit: 0
            })
            this.$router.push({ name: 'delivery-address' })
        }
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    }
}
</script>
